import { useCallback, useLayoutEffect, useState } from 'react';
import { Size } from '@ff-os/shared-utils/types/Size';

export const useViewportSize = (): Size => {

    const [windowSize, setWindowSize] = useState<Size>(captureWindowSize());
    const [screenSize, setScreenSize] = useState<Size>(captureScreenSize());

    const handleResize = useCallback(() => {

        const hasRotatedDevice = !isSameSize(captureScreenSize(), screenSize);
        const isResizingWindow = !isSameSize(captureWindowSize(), windowSize);
        const hasOpenedOnScreenKeyboard = captureWindowSize().width === windowSize.width
            && captureWindowSize().height < 0.8 * windowSize.height;

        if (hasRotatedDevice || (isResizingWindow && !hasOpenedOnScreenKeyboard)) {
            setWindowSize(captureWindowSize());
            setScreenSize(captureScreenSize());
        }
    }, [screenSize, windowSize]);

    useLayoutEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [handleResize]);

    return windowSize;
};

const isSameSize = (a: Size, b: Size) => {
    return a.width === b.width
        && a.height === b.height;
};

const captureScreenSize = (): Size => ({
    width: window.screen.width,
    height: window.screen.height
});

const captureWindowSize = (): Size => ({
    width: window.innerWidth,
    height: window.innerHeight
});